<template>
    
    <v-row>
        <v-col cols="12">
            <TableC nombre="Conductores" :table="conductor" :type="type" :headerss="header" :loadings="loading"/>
        </v-col>
    </v-row>
  
</template>
<script>

import Table from '../../../../component/helpers/tools/table'
import Single from '../../../../component/helpers/tools/single'
import TableC from '../../../../component/helpers/tools/tablesearchVehiculo'

export default {
    
    components:{
        Table,
        Single,
        TableC
    },

    data(){
        return {
            type:'Conductores',
            header: [
                {
                    text: 'Nombre del conductor',
                    align: 'left',
                    sortable: false,
                    value: 'name',
                },
                { text: 'Cédula', value: 'dni' },
                { text: 'Fecha modificación', value: 'updated_at' },
                
            ]

        }
    },

    computed: {
        conductor(){
            return this.$store.state.conductor;
        },
        loading(){
            return this.$store.state.loading_dashboard
        },

        single(){
            return this.$store.state.select_table
        }


    },


}
</script>